import React from 'react';
import headerBgUrl from '../../lab-test/v2/Icons/AddOnStyledHeader.svg';
import { ReactComponent as TestIcon } from '../../lab-test/v2/Icons/Test.svg';
import { ReactComponent as OutlinedCrossIcon } from '../../lab-test/v2/Icons/OutlinedCrossIcon.svg';
import { ReactComponent as SavingsBadgeIcon } from '../../lab-test/v2/Icons/SavingsBadge.svg';
import styles from './RecommendedPackageModal.module.scss';

const TestRow = ({ test, isLast }) => (
  <div className={`${styles.testRow} ${isLast ? styles.testRowLast : ''}`}>
    <TestIcon width={16} height={16} className={styles.testIcon} />
    <span className={styles.testName}>{test.name}</span>
  </div>
);

const RecommendedPackageModal = ({ pkg, onClose, onBook }) => (
  <div className={styles.overlay}>
    {/* Close button above modal */}
    <button className={styles.closeBtn} onClick={onClose}>
      <OutlinedCrossIcon width={24} height={24} />
    </button>

    <div className={styles.root}>
      {/* Recommended badge pinned to top-left border */}
      {pkg.isRecommended && (
        <div className={styles.recommendedBadge}>
          <span className={styles.recommendedText}>Recommended</span>
        </div>
      )}

      {/* Header */}
      <div
        className={styles.header}
        style={{ backgroundImage: `url(${headerBgUrl})` }}
      >
        <div className={styles.headerBody}>
          <div className={styles.headerLeft}>
            <span className={styles.savingText}>{pkg.headerMessage}</span>
          </div>
          <button className={styles.bookBtn} onClick={onBook}>
            <span className={styles.bookText}>Book</span>
          </button>
        </div>
      </div>

      {/* Scrollable body */}
      <div className={styles.body}>
        <span className={styles.testCount}>
          {pkg.packageTestCount} Tests Included
        </span>

        {pkg.prescribedTests?.length > 0 && (
          <>
            <span className={styles.sectionLabel}>Prescribed Tests</span>
            <div className={styles.testList}>
              {pkg.prescribedTests.map((test, i) => (
                <TestRow
                  key={test.id}
                  test={test}
                  isLast={i === pkg.prescribedTests.length - 1}
                />
              ))}
            </div>
          </>
        )}

        {pkg.additionalTests?.length > 0 && (
          <>
            <span className={styles.sectionLabel}>Additional Tests</span>
            <div className={styles.testList}>
              {pkg.additionalTests.map((test, i) => (
                <TestRow
                  key={test.id}
                  test={test}
                  isLast={i === pkg.additionalTests.length - 1}
                />
              ))}
            </div>
          </>
        )}
      </div>

      {/* Savings bar */}
      <div className={styles.savingsBar}>
        <SavingsBadgeIcon width={16} height={16} style={{ flexShrink: 0 }} />
        <span className={styles.savingsBarText}>{pkg.userMessage}</span>
      </div>

      {/* You Pay */}
      <div className={styles.payRow}>
        <span className={styles.youPayLabel}>You Pay</span>
        <div className={styles.priceGroup}>
          {pkg.mrp && (
            <span className={styles.mrpText}>₹{pkg.mrp}</span>
          )}
          <span className={styles.totalCostText}>₹{pkg.totalCost}</span>
        </div>
      </div>
    </div>
  </div>
);

export default RecommendedPackageModal;
